import Globalized from './globalized';
import {extend} from './mixin';
import {
  NAMESPACE,
  DEFAULT_TIMEOUT,
  PROMISES_PROPERTY,
  DEFAULT_LOG_TEMPLATE
} from '../constants';
import {showLog} from '../logger';

const
  _defers  = {},
  _hasOwnProperty = Object.prototype.hasOwnProperty
;

const Deferred = {
  whenUntil(promiseNS, time = DEFAULT_TIMEOUT) {
    showLog('[Deferred] whenUntil', {promiseNS, time});
    return new window.RSVP.Promise((resolve, reject) => {
      setTimeout(reject, time);
      this.when(promiseNS).then(resolve);
    });
  },

  when(promiseNS) {
    var owner, name, global;

    showLog('[Deferred] when', promiseNS);

    if (!promiseNS) {throw Error(`${DEFAULT_LOG_TEMPLATE} [Deferred] At least 1 argument needed. 0 passed.`);}
    [owner, name] = promiseNS.split(':');
    if (!owner || !name) {throw Error(`${DEFAULT_LOG_TEMPLATE} [Deferred] Illegal promise namespace name. Expected "owner:name".`);}

    if (_hasOwnProperty.call(_defers, promiseNS)) {return _defers[promiseNS].promise;}

    global = this.createGlobal(`${NAMESPACE}.${owner}.${PROMISES_PROPERTY}`);
    global[name] = window.RSVP.defer();
    _defers[promiseNS] = global[name];

    return global[name].promise;
  },

  promised(promiseNS, value) {
    var owner, name, global;

    showLog('[Deferred] promised', {promiseNS, value});

    if (!promiseNS) {throw Error(`${DEFAULT_LOG_TEMPLATE} [Deferred] At least 1 argument needed. 0 passed.`);}
    [owner, name] = promiseNS.split(':');
    if (!owner || !name) {throw Error(`${DEFAULT_LOG_TEMPLATE} [Deferred] Illegal promise namespace name. Expected "owner:name".`);}

    if (_hasOwnProperty.call(_defers, promiseNS)) {
      _defers[promiseNS].resolve(value);
      return this;
    }

    global = this.createGlobal(`${NAMESPACE}.${owner}.${PROMISES_PROPERTY}`);
    global[name] = window.RSVP.defer();
    global[name].resolve(value);
    _defers[promiseNS] = global[name];

    return this;
  }
};

extend(Deferred, Globalized);

export default Deferred;



// WEBPACK FOOTER //
// ./src/mixins/deferred.js